import { Adjust, Mail, Phone, Place } from '@mui/icons-material'
import { Card, styled, Box } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const CardDiv = styled(Card)(({theme}) => ({
    cursor:"pointer",
    padding:"30px",
    background:"#f1f1f1",
    transition:"0.3s",
    "&:hover":{
        background:"#f9f9f9",   
    },
    "& h3":{
        margin:"0",
        paddingBottom:"20px",
    },
    "& svg":{
        marginRight:"10px"
    },
    [theme.breakpoints.down("md")]: {
        padding: "10px",
        width: "300px",
      },
}))

const WarehouseCard = ({warehouse, fittings}) => {

    const navigate = useNavigate();

    const handleWarehouse = () => {
         //fittings ? navigate(`/fittings/orders/${warehouse.erplyID}/tab_express`) : navigate(`/warehouse_orders/orders/${warehouse.erplyID}/tab_to_pick`);
        fittings ? navigate(`/fittings/orders/${warehouse.LocationID}/tab_express`) : navigate(`/warehouse_orders/orders/${warehouse.LocationID}/tab_to_pick`);
    
    }
  
    return (
    <CardDiv onClick={handleWarehouse}>
        <Box textAlign="center">
            <h3>{warehouse.LocationName}</h3>
        </Box>
        <Box display={"flex"} alignItems={"center"} mb={1}>
            <Adjust fontSize='small' color='primary' /> <span>{warehouse.ENTITY}</span>
        </Box> 
        <Box display={"flex"} alignItems={"center"} mb={1}>
            <Place fontSize='small' color='primary' /> <span>{warehouse.ADDRESS}</span>
        </Box> 
        <Box display={"flex"} alignItems={"center"} mb={1} >
            <Mail fontSize='small' color='primary' /> <span style={{ width:"400px", overflow:"hidden" }}>{warehouse.EMAIL}</span>
        </Box> 
        <Box display={"flex"} alignItems={"center"} mb={1}>
            <Phone fontSize='small' color='primary' /> <span>{warehouse.PHONE}</span>
        </Box> 
    </CardDiv>
  )
}

export default WarehouseCard